import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.5 4.805c0-.764.572-1.305 1.184-1.305.611 0 1.184.54 1.184 1.305S7.295 6.11 6.684 6.11c-.612 0-1.184-.54-1.184-1.305M6.684 2C5.159 2 4 3.3 4 4.805c0 1.247.795 2.353 1.934 2.696v8.995C4.794 16.84 4 17.946 4 19.192c0 1.506 1.16 2.805 2.684 2.805s2.684-1.3 2.684-2.805c0-1.247-.795-2.352-1.934-2.696V7.501c.903-.273 1.59-1.024 1.836-1.946h.05a7.25 7.25 0 0 1 7.25 7.25v3.691c-1.139.344-1.934 1.45-1.934 2.696 0 1.506 1.16 2.805 2.684 2.805s2.684-1.3 2.684-2.805c0-1.247-.795-2.352-1.934-2.696v-3.69a8.75 8.75 0 0 0-8.75-8.75h-.05C8.96 2.892 7.947 2 6.684 2m0 15.887c-.612 0-1.184.54-1.184 1.305s.572 1.305 1.184 1.305c.611 0 1.184-.54 1.184-1.305s-.573-1.305-1.184-1.305m9.452 1.305c0-.765.573-1.305 1.184-1.305.612 0 1.184.54 1.184 1.305s-.572 1.305-1.184 1.305c-.611 0-1.184-.54-1.184-1.305",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }